export default {
	bruttoProductionModal: {
		id: 'GKCL-569',
		name: 'Spárovaná produkce',
	},

	campaignDashboards: {
		central: {
			id: 'GKCL-167',
			name: 'Dashboard centrála',
		},

		region: {
			id: 'GKCL-171',
			name: 'Dashboard region',
		},

		manager: {
			id: 'GKCL-163',
			name: 'Dashboard manažer',
		},

		seller: {
			id: 'GKCL-162',
			name: 'Dashboard obchodník',
		},

		ppz: {
			id: 'GKCL-165',
			name: 'Dashboard podobchodník',
		},
	},

	campaignList: {
		id: 'GKCL-141',
		name: 'Seznam kampaní',

		newCampaignModal: {
			id: 'GKCL-583',
			name: 'Nová kampaň',
		},
	},

	campaignOverview: {
		id: 'GKCL-166',
		name: 'Základní přehled kampaní',

		orderModal: {
			id: 'GKCL-550',
			name: 'Objednávka',
		},
	},

	campaignRegionNominations: {
		id: 'GKCL-144',
		name: 'Přehled nominací v regionech',
	},

	campaignSubsellerNominations: {
		id: 'GKCL-191',
		name: 'Přehled nominovaných obchodníků',
	},

	campaignSettings: {
		campaign: {
			id: 'GKCL-142',
			name: 'Kampaň',
		},

		startupCurve: {
			id: 'GKCL-172',
			name: 'Náběhová křivka',
		},

		additionalData: {
			id: 'GKCL-146',
			name: 'Doplňující data',
		},

		states: {
			id: 'GKCL-145',
			name: 'Stavy',
		},

		guarantors: {
			id: 'GKCL-143',
			name: 'Garanti',
		},

		editGuarantorModal: {
			id: 'GKCL-578',
			name: 'Editace garanta regionu',
		},

		loadTemplateModal: {
			id: 'GKCL-547',
			name: 'Načtení ze šablony',
		},

		saveTemplateModal: {
			id: 'GKCL-548',
			name: 'Uložení šablony',
		},
	},

	campaignManagement: {
		id: 'GKCL-152',
		name: 'Řízení kampaní',
	},

	contactDetail: {
		id: 'GKCL-153',
		name: 'Detail kontaktu',
	},

	contactHistory: {
		id: 'GKCL-180',
		name: 'Kontaktní historie',
	},

	contacts: {
		id: 'GKCL-183',
		name: 'Moje kontakty',

		contactTakeModal: {
			id: 'GKCL-555',
			name: 'Převzetí kontaktu',
		},
	},

	dashboard: {
		id: 'GKCL-202',
		name: 'Souhrnný dashboard',
	},

	dashboardManager: {
		id: 'GKCL-203',
		name: 'Souhrnný dashboard manažera',
	},

	errorReportAppBar: {
		id: 'GKCL-529',
		name: 'Úplný přehled chyb',
	},

	leadDetail: {
		id: 'GKCL-196',
		name: 'Detail příležitosti',
	},

	leadTaskHistoryModal: {
		id: 'GKCL-507',
		name: 'Historie úkolu / příležitosti',
	},

	marketPlace: {
		id: 'GKCL-193',
		name: 'Příležitosti',
	},

	policyOverview: {
		id: 'GKCL-103',
		name: 'Přehled PS',

		advancedSearchModal: {
			id: 'GKCL-581',
			name: 'Rozšířené vyhledávání',
		},

		subordinateLoginSearchModal: {
			id: 'GKCL-525',
			name: 'Vyhledání podobchodníka',
		},
	},

	productionControl: {
		id: 'GKCL-200',
		name: 'Kontrola produkce',

		reportProductionControlModal: {
			id: 'GKCL-582',
			name: 'Report kontroly produkce',
		},
	},

	productionControlDetail: {
		id: 'GKCL-201',
		name: 'Detail případu',
	},

	producedProduction: {
		id: 'GKCL-188',
		name: 'Vykázané dokumenty',

		reportModal: {
			id: 'GKCL-564',
			name: 'Uzavření výkazu dokumentů',
		},

		newModal: {
			id: 'GKCL-561',
			name: 'Výkaz nového dokumentu',
		},
	},

	taskCreatingPages: {
		backOffice: {
			id: 'GKCL-190',
			name: 'Úkol BackOffice',
		},

		clientSearchModal: {
			id: 'GKCL-520',
			name: 'Vyhledání klienta',
		},

		contactClient: {
			id: 'GKCL-199',
			name: 'Úkol Kontaktuj klienta',
		},

		manualLead: {
			id: 'GKCL-195',
			name: 'Manuální příležitost',
		},

		mobileScanning: {
			id: 'GKCL-189',
			name: 'Úkol Skenování',
		},

		policySearchModal: {
			id: 'GKCL-519',
			name: 'Výsledek vyhledání PS',
		},

		sellerRequest: {
			id: 'GKCL-118',
			name: 'Požadavek na obchodníka',
		},

		userSearchModal: {
			id: 'GKCL-510',
			name: 'Výsledek vyhledání uživatele',
		},
	},

	taskDetail: {
		id: 'GKCL-106',
		name: 'Detail úkolu',

		taskCopyEmailModal: {
			id: 'GKCL-524',
			name: 'Odeslání kopie úkolu e-mailem',
		},

		taskForwardingModal: {
			id: 'GKCL-509',
			name: 'Úkoly k předání',
		},

		taskPszpNoticeModal: {
			id: 'GKCL-531',
			name: 'Avízo dožití',
		},

		printNein: {
			id: 'GKCL-136',
			name: 'Tisk NEIN',
		},
	},

	tasksOverview: {
		id: 'GKCL-117',
		name: 'Úkoly a informace',
	},

	taskSearch: {
		id: 'GKCL-128',
		name: 'Vyhledat úkol',
	},

	taskStatistics: {
		id: 'GKCL-111',
		name: 'Statistika úkolů',
	},

	semaphore: {
		id: 'GKCL-197',
		name: 'Semafor',

		semaphoreFeedbackDetailModal: {
			id: 'GKCL-579',
			name: 'Zpětná vazba',
		},
	},

	settings: {
		notificationSending: {
			id: 'GKCL-198',
			name: 'Nastavení odesílání notifikací',
		},

		informationCreation: {
			id: 'GKCL-160',
			name: 'Nastavení vzniku informací',
		},

		marketPlaceAgencies: {
			id: 'GKCL-204',
			name: 'Nastavení oblastí',
		},

		editAgencyModal: {
			id: 'GKCL-584',
			name: 'Editace oblasti',
		},

		customSettingsModal: {
			id: 'GKCL-580',
			name: 'Vlastní nastavení',
		},
	},

	subordinateUsers: {
		id: 'GKCL-104',
		name: 'Podřízení uživatelé',
	},

	roboAdvisory: {
		id: 'GKCL-194',
		name: 'Analýzy REDy',

		roboAdvisoryHandoverModal: {
			id: 'GKCL-526',
			name: 'Předání produktových analýz',
		},
	},

	unlockedClients: {
		id: 'GKCL-192',
		name: 'Odemčení klienti',
	},

	wrappersAndFallbacks: {
		error: {
			id: 'GKCL-902',
		},

		iascError: {
			id: 'GKCL-904',
		},

		migrationInProgress: {
			id: 'GKCL-905',
		},

		noAccess: {
			id: 'GKCL-903',
		},

		logIn: {
			id: 'GKCL-900',
		},

		logOut: {
			id: 'GKCL-901',
		},
	},
};
